import { render } from "./NewsletterCategoriesConfigView.vue?vue&type=template&id=886783f0&scoped=true"
import script from "./NewsletterCategoriesConfigView.vue?vue&type=script&lang=js"
export * from "./NewsletterCategoriesConfigView.vue?vue&type=script&lang=js"

import "./NewsletterCategoriesConfigView.vue?vue&type=style&index=0&id=886783f0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-886783f0"

export default script